import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
function MyRequests() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        getMyRequests();
    }, []);
    const getMyRequests = () => {
        setLoading(true);
        axios
            .get(baseUrl + "my-workflow-requests/")
            .then((res) => {
                setRequests(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error",
                    "Unable to load your requests",
                    "error");
            });
    };
    const getStatusClass = (status) => {
        switch (status) {
            case "COMPLETED":
                return "bg-success";
            case "REJECTED":
                return "bg-danger";
            case "PENDING":
                return "bg-warning";
            default:
                return "bg-secondary";
        }
    };
    return (
        <div className="container-fluid mt-3">


            <div className="card shadow">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        My Requests

                    </h5>


                </div>


                <div className="card-body">


                    {loading && (
                        <div className="alert alert-info">

                            Loading Requests...

                        </div>
                    )
                    }


                    {requests.length === 0 && !loading && (
                        <div className="alert alert-warning">

                            No Requests Found

                        </div>
                    )
                    }


                    <div className="row">


                        {requests.map((req) => (
                            <div

                                key={req.id}

                                className="col-lg-3 col-md-4 col-sm-6 mb-4"

                            >


                                <div className="card app-card shadow-sm">


                                    <div className="app-card-header">


                                        📄 {req.document_type}


                                    </div>


                                    <div className="app-card-body">


                                        <p>

                                            <strong>
                                                Document ID:
                                            </strong>

                                            {" "}

                                            {req.document_id}

                                        </p>


                                        <p>

                                            <strong>
                                                Workflow:
                                            </strong>

                                            {" "}

                                            {req.workflow_name}

                                        </p>


                                        <p>

                                            <strong>
                                                Current Stage:
                                            </strong>

                                            {" "}

                                            {req.current_stage_name}

                                        </p>


                                        <p>

                                            <strong>
                                                Created Date:
                                            </strong>

                                            {" "}

                                            {req.created_date}

                                        </p>


                                        <p>

                                            <strong>
                                                Status:
                                            </strong>

                                            {" "}

                                            <span

                                                className={"badge " + getStatusClass(req.status)}

                                            >

{req.status}

</span>


                                        </p>


                                    </div>


                                    <div className="app-card-footer">


                                        <button

                                            className="btn btn-primary w-100"

                                            onClick={() => {
                                                window.location.href =
                                                    `/workflow-history?transaction=${req.id}`;
                                            }}

                                        >

                                            View History

                                        </button>


                                    </div>


                                </div>


                            </div>
                        ))
                        }


                    </div>


                </div>


            </div>


        </div>
    );
}
export default MyRequests;